import React, {useState, useRef, useEffect} from 'react';
import styled from 'styled-components';
import {Wrapper, Header, Footer, SumbitForm} from "./Form";
import { LoadingIcon } from '../../supplementary_components/loading_icon';

const Message = styled.div`
    font-size:1.2rem;
    padding-top:2rem;
    line-height:1.9rem;
    font-weight:bold;
    color:var(--gray);
`;
export const Content = styled.div`
    margin: 0.1rem 0;
    width:45rem;
    max-height:60vh;
    overflow-y: scroll;
    padding: 0 2rem;
`;

export const ConfirmationDialogue = ({closePopup, popupData}) =>{
    
    const [loading, setLoading] = useState({state:false, height:'0'});
    const pageRef = useRef(null);
    useEffect(
        () => {
            if (pageRef != null){
                setLoading({state:false, height:`${pageRef.current.clientHeight}px`})
            }   
        }, [pageRef]
    );
    const changeLoadingState = (loadingState) => {
        setLoading({state:  loadingState, height: loading.height})
    }


    const sumbitForm = (event) => {
        event.preventDefault();
        changeLoadingState(true);
        popupData.action((success)=>{
            changeLoadingState(false)
            if(success){
                closePopup()
            }
        });
    }
    
    return <Wrapper ref={pageRef} >
        <LoadingIcon state={loading.state} height={loading.height} />
        <Header > <span>{popupData.formTitle}</span></Header>
        <Content className="formContent">
            <SumbitForm method={popupData.method} autoComplete="off" id={popupData.name} onSubmit={(e)=>{sumbitForm(e)}} >
                <Message>{popupData.message}</Message>
                {/* {formConf.columns.map((column, index)=>{
                    return <InputFieldDelegate 
                            index = {index}
                            key={column.name}
                            column={column}
                        />
                })} */}
                
            </SumbitForm>
        </Content>
        <Footer>
            <div className="non-selectable" style={{display:popupData.oneButton ? 'none':'block'}} onClick={()=>{popupData.cancelAction?popupData.cancelAction(closePopup):closePopup()}}>{popupData.cancelButtonText ? popupData.cancelButtonText : "Cancel" }</div>
            <div> <input type="submit" form={popupData.name} value={popupData.submitTitle}/></div>
        </Footer>
    </Wrapper>
    
}